import React from "react";
import NavigationButtons from "../../../components/NavigationButtons";

const initialGrades = [
    {
        criterion: "A: Focus and method",
        commentary:
            "The research question could have been better phrased as one question, but the intent is both clear and appropriate for computer science. The topic is given both context and some degree of worthiness in the introduction. The methodology is outlined but the performance metric used is unclear",
        grade: "5/6",
    },
    {
        criterion: "B: Knowledge and understanding",
        commentary:
            "Only general descriptions are given in the early part of the essay—although this demonstrates some understanding, it limits the mark to the middle band. The selection of source material is appropriate and generally recent, which helped in pushing the mark to the top of this band.",
        grade: "4/6",
    },
];

const finalGrades = [
    {
        criterion: "A: Focus and method",
        commentary:
            "The research question could have been better phrased as one question, but the intent is both clear and appropriate for computer science. The topic is given both context and some degree of worthiness in the introduction.",
        grade: "5/6",
    },
    {
        criterion: "B: Knowledge and understanding",
        commentary:
            "Only general descriptions are given in the early part of the essay—although this demonstrates some understanding, it limits the mark to the middle band. The selection of source material is appropriate and generally recent, which helped in pushing the mark to the top of this band.",
        grade: "5/6",
    },
];
const comparisonInsights = initialGrades.map((item, index) => ({
    criterion: item.criterion,
    commentaryDifference:
        item.commentary !== finalGrades[index].commentary
            ? "Some refinements made in the explanation."
            : "No changes in commentary.",
    gradeDifference:
        item.grade !== finalGrades[index].grade
            ? `Grade improved from ${item.grade} to ${finalGrades[index].grade}.`
            : "No grade change.",
}));

const InitialGrades = () => {
    return (
        <div className="p-8">
            <div className='flex flex-row items-center justify-between pl-3 pr-3 gap-4 bg-gray-200 h-[70px] rounded-lg border border-blue-500 w-full'>
                <div>
                    <p className='font-medium'>Subject: <span className='font-medium text-blue-400'>English</span></p>
                </div>
                <div>
                    <p className='font-medium'>Topic: <span className='font-medium text-blue-400'>Creative Writing</span></p>
                </div>
                <div>
                    <p className='font-medium'>Essay Completion Time: <span className='font-medium text-blue-400'>42 Days</span></p>
                </div>
                <div>
                    <p className='font-medium'>Graded:<span className='font-medium text-red-500'>No</span></p>
                </div>

                <div className='flex flex-row gap-4 items-center'>
                    <p className='font-medium'>Supervisor</p>
                    <div className='flex flex-col '>
                        <img
                            src={require("../../../assets/Profile Picture.png")}
                            alt="Profile"
                            className="w-10 h-10 rounded "
                        />
                        <p className='text-[12px] text-blue-400'>View Details</p>
                    </div>
                </div>

            </div>
            <div className='bg--400 flex flex-col w-full p-4'>
               <p className='text-2xl text-medium'>Versions:</p>
               <div className='flex items-center gap-4 underline text-blue-400'>
                <p className='text-blue-400'>Initial Draft</p>
                <p className='text-blue-400'>Second Draft</p>
                {/* <p className='text-blue-400'>Final Essay</p> */}

               </div>
               </div>

        <div className="flex w-full ">
 
            <div className=" p-4">
                {/* <h2 className=" rounded-t-lg text-center bg-black text-white font-medium ">Initial Grades</h2> */}

                <table className="border-b-2 w-full">
                    <thead>
                        <tr className=" border-b-2">
                            <th className=" p-4">Criterion</th>
                            <th className=" p-4 text-left">Commentary</th>
                            <th className=" p-4 text-nowrap">Initial Grades</th>
                        </tr>
                    </thead>
                    <tbody>
                        {initialGrades.map((item, index) => (
                            <tr key={index} className="border-b-2 text-sm align-text-top">
                                <td className=" p-2 h-[300px]">{item.criterion}</td>
                                <td className=" p-2 h-[300px]">{item.commentary}</td>
                                <td className="p-2 text-xl font-semibold text-center">
                                    <span className='bg-gray-300 w-[70px] h-[30px] rounded-md flex items-center justify-end  gap-1'> {item.grade}
                                        <span className='flex items-center self-end'>
                                            <img src={require("../../../assets/ai.png")} alt="" className='w-[10px] h-[10px]' />
                                            <img src={require("../../../assets/ai.png")} alt="" className='w-[15px] h-[15px] mt-3' />
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* <div className="bg-yellow-500 w-[2px] mr-1 mt-4"></div> */}

            {/* <div className="w-1/2 p-4">
                <h2 className=" rounded-t-lg text-center bg-black text-white font-medium ">Final Grades</h2>

                <table className=" border-b-2 w-full">
                    <thead>
                        <tr className="border-b-2">
                            <th className=" p-2">Criterion</th>
                            <th className=" p-2">Commentary</th>
                            <th className=" p-2">Grades</th>
                        </tr>
                    </thead>
                    <tbody>
                        {finalGrades.map((item, index) => (
                            <tr key={index} className="border-b-2 text-sm align-text-top">
                                <td className=" p-2 h-[300px]">{item.criterion}</td>
                                <td className=" p-2 h-[300px]">{item.commentary}</td>
                                <td className="p-2 text-xl font-semibold text-center">
                                    <span className='bg-gray-300 w-[70px] h-[30px] rounded-md flex items-center justify-end  gap-1'> {item.grade}
                                        <span className='flex items-center self-end'>
                                            <img src={require("../../../assets/ai.png")} alt="" className='w-[10px] h-[10px]' />
                                            <img src={require("../../../assets/ai.png")} alt="" className='w-[15px] h-[15px] mt-3' />
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div> */}
            {/* <div className="bg-yellow-500 w-[2px] mr-1 mt-4"></div> */}
            {/* <div className="w-1/2 p-4">

                <table className="bord bo00 w-full mt-7 ">
                    <thead>
                        <tr className="  text-sm">
                            <th className=" p-2 w-full text-start border-b-2">Comparison Insights</th>
                        </tr>
                    </thead>
                    <tbody>
                        {comparisonInsights.map((item, index) => (
                            <tr key={index} className="border-b-2 text-sm  align-text-top">
                                <td className=" p-2 h-[300px]">{item.commentaryDifference}<br />
                                    {item.gradeDifference}</td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div> */}
            
        </div>
        <div className="flex items-center mt-4 ">
      <NavigationButtons dashboardLink="/supervisor/dashboard"/>
      <button  className={` text-white bg-blue-600  h-[40px] w-[180px] font-medium rounded-lg  `}>
             Get Final Grades
            </button>
            </div>
        </div>
    );
};
export default InitialGrades